import LogoInversedCircle from './LogoInversedCircle.vue';

export default LogoInversedCircle;
